import { Text, TextSize } from 'components'
import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

export const TableContent = styled.div`
  display: flex;
  gap: 20px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    flex-direction: column;
    gap: 0;
  `};
`

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const TableSeparator = styled.div`
  width: 1px;
  background-color: ${GLOBAL_COLORS.separatorBg};
  margin: 70px 20px 20px 0;
`

export const SecondInfoFragment = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
`

export const StyledText = styled(Text)`
  margin-top: 10px;
  font-size: ${TextSize.small};
  text-decoration: underline;
  color: ${GLOBAL_COLORS.coreGrey};
  transition: 0.4s all;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
  &:active {
    opacity: 0.4;
  }
`
